import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { image } from 'services'
import { Button } from 'controls'
import styles, { button } from './styles'

class EmailConfirmation extends PureComponent {
  static propTypes = {

  }

  static defaultProps = {

  }

  render() {
    return (
      <div className="container">
        <h1>Confirmación de correo electrónico</h1>
        <h2>Tu tarea: Revisa tu correo electronico y activa tu cuenta.</h2>
        <img className="confirm-email-image" src={image('confirm-your-email', 'confirm-your-email.svg')} />
        <h2>¿No has recibido un correo de nosotros? Re-envía la confirmación</h2>
        <div className="buttons-container">
          <Button color="primary" outline>
            Re-enviar email
          </Button>

          <Button color="primary">
            Salir
          </Button>
        </div>
        <style jsx>{styles}</style>
        <style jsx global>{button}</style>
      </div>
    )
  }
}

export default EmailConfirmation
